import React, {useContext, useEffect, useMemo, useState} from 'react';
import {useManagePostRequest} from '../../hooks/useManagePostRequest/useManagePostRequest';
import useDidMountEffect from '../../hooks/useDidMountEffect/useDidMountEffect';
import { useGetRequest } from '../../hooks/useGetRequest/useGetRequest';
import { AuthContext } from '../../hooks/context/authContext';
import Wrapper from '../../components/atoms/DirectorioWrapper';
import PageHeader from '../../components/pageHeader/PageHeader';
import SearchBar from '../../components/pageComponents/SearchBar';
import FormSelect from '../../components/atoms/Select';
import PageButtons from '../../components/pageComponents/PageButtons';
import PaginatorV2 from '../../components/pageComponents/PaginatorV2';
import SpinnerLoading from '../../components/pageComponents/SpinnerLoading';
import FormDatePicker from '../../components/atoms/DatePicker';
import EstadoFilter from '../../components/atoms/EstadoFilter';
import TableWebBody from './TableWebBody';
import ModalCrearPostulante from './ModalCrearPostulante';
import {handleFind, initialAllOptionPromises, jsonNoEstaVacio, updateFiltersWithExtraData} from '../../helper/utils';
import {mostrarMensajeDeErrorConToast, responseCode200} from '../../consumers/httpRequiestsUtils';
import {
    getAllEstadosPostulanteAPI,
    getPostulanteByIdAPI,
    getPostulantesIndexAPI,
    searchPostulantesAPI
} from '../../consumers/backendApisUrls';
import ModalMensajePostulanteActivo from "./ModalMensajePostulanteActivo";
import SidebarProcesosSeleccion from '../../components/pageComponents/SidebarProcesosSeleccion';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';

const NuevosPostulantes = () => {
  const KEYS_FILTERS = { Estados: "IdsEstados" };
  const { state } = useContext(AuthContext);

  const [formValues, setFormValues] = useState([]);
  const [extraData, setExtraData] = useState({});
  const [allFilters, setAllFilters] = useState([]);
  const [filters, setFilters] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [loading, setLoading] = useState(true);
  const [searchLoading, setSearchLoading] = useState(false);
  const [tableRefreshLoading, setTableRefreshLoading] = useState(false);
  const [searchCriteria, setSearchCriteria] = useState("");
  const [paginator, setPaginator] = useState({ CurrentPage: 1 });
  const [showModalCrear, setShowModalCrear] = useState(false);
  const [postulanteToEdit, setPostulanteToEdit] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showModalMensajeIsPostulanteActivo, setShowModalMensajeIsPostulanteActivo] = useState(false);
  const [mensajeIsPostulanteActivo, setMensajeIsPostulanteActivo] = useState("");
  const [fechaRegistroInicio, setFechaRegistroInicio] = useState(null);
  const [fechaRegistroFin, setFechaRegistroFin] = useState(null);
  const [fechaRegistroFiltro, setFechaRegistroFiltro] = useState({ inicio: null, fin: null });
  const [uuidKey, setUuidKey] = useState(uuidv4());

  const [executePost] = useManagePostRequest();
  const [executeGet] = useGetRequest();

  const allFiltersPromises = () => {
    return [
      executeGet(getAllEstadosPostulanteAPI())
    ];
  };

  const init = async () => {
    try {
      await initialAllOptionPromises(allFiltersPromises, Object.values(KEYS_FILTERS), setAllFilters);
      setExtraData({});
      await manageSearch(1, false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const manageSearch = async (pageNumber = 1, showLoading = true) => {
    if (showLoading) setSearchLoading(true);
    const api = searchPostulantesAPI(searchCriteria.trim(), pageNumber, 20);
    
    try {
      const response = await executeGet(api);
      if (responseCode200(response)) {
        sucessManageSearchCallback(response);
      } else {
        console.error('Error response:', response);
        mostrarMensajeDeErrorConToast(response);
      }
    } catch (error) {
      console.error('Error en manageSearch:', error);
    } finally {
      if (showLoading) setSearchLoading(false);
    }
  };

  const refreshTableAfterCorreo = async () => {
    setTableRefreshLoading(true);
    try {
      await manageSearch(paginator.CurrentPage || 1, false);
    } finally {
      setTableRefreshLoading(false);
    }
  };

  const manageSearchForPaginator = async () => {
    await manageSearch(paginator.CurrentPage || 1, false);
  };

  const updatePostulanteInList = (updatedPostulante) => {
    console.log('🔄 updatePostulanteInList iniciando con:', updatedPostulante);
    
    setFormValues(currentValues => {
      const newValues = currentValues.map(postulante => {
        const postulanteId = postulante.IdPostulacion || postulante.idPostulacion;
        const updatedId = updatedPostulante.IdPostulacion || updatedPostulante.idPostulacion;
        const matchesId = postulanteId === updatedId;
        
        if (matchesId) {
         // console.log('🎯 Postulante encontrado para actualizar! ID:', postulanteId);
         // console.log('📝 Datos anteriores:', postulante);
         // console.log('📝 Datos nuevos:', updatedPostulante);
          
          // Normalizar los datos actualizados
          const normalizedUpdate = {
            ...postulante,
            ...updatedPostulante,
            idPostulacion: updatedId,
            IdPostulacion: updatedId,
            // Preservar evaluaciones del update
            evaluaciones: updatedPostulante.evaluaciones || postulante.evaluaciones || []
          };
          
          // console.log('✅ Postulante actualizado con evaluaciones:', normalizedUpdate);
          return normalizedUpdate;
        }
        return postulante;
      });
      
      // console.log('✅ Lista actualizada');
      return newValues;
    });
  };

  const addPostulanteToList = (newPostulante) => {
    setFormValues(currentValues => [newPostulante, ...currentValues]);
    setPaginator(prev => ({
      ...prev,
      TotalItems: prev.TotalItems + 1,
      LastItemPage: Math.min(prev.LastItemPage + 1, prev.TotalItems + 1)
    }));
  };

  const removePostulanteFromList = (idPostulante) => {
    setFormValues(currentValues => 
      currentValues.filter(postulante => 
        postulante.IdPostulacion !== idPostulante && 
        postulante.idPostulacion !== idPostulante
      )
    );
    setPaginator(prev => ({
      ...prev,
      TotalItems: Math.max(prev.TotalItems - 1, 0),
      LastItemPage: Math.max(prev.LastItemPage - 1, 0)
    }));
  };

  const updatePostulanteStatus = (idPostulante, newStatus, isLoading = false) => {
    setFormValues(currentValues => 
      currentValues.map(postulante => {
        const matchesId = postulante.IdPostulacion === idPostulante || postulante.idPostulacion === idPostulante;
        if (matchesId) {
          return { 
            ...postulante, 
            // Actualizar ambos formatos (mayúscula y minúscula) para compatibilidad
            EstadoPostulante: isLoading ? "Procesando..." : newStatus,
            estadoPostulante: isLoading ? "Procesando..." : newStatus, // ← Campo correcto para la UI
            IdEstado: isLoading ? postulante.IdEstado : (newStatus === "Cancelado" ? 25 : postulante.IdEstado),
            idEstado: isLoading ? (postulante.idEstado || postulante.IdEstado) : (newStatus === "Cancelado" ? 25 : (postulante.idEstado || postulante.IdEstado)) // ← Campo correcto para la UI
          };
        }
        return postulante;
      })
    );
  };

  const updatePostulanteFechaLimite = (idPostulante) => {
    const fechaLimite = new Date();
    fechaLimite.setDate(fechaLimite.getDate() + 5);
    const fechaFormateada = fechaLimite.toLocaleDateString('es-PE', { 
      day: '2-digit', 
      month: '2-digit', 
      year: '2-digit' 
    });

    setFormValues(currentValues => 
      currentValues.map(postulante => {
        const matchesId = postulante.IdPostulacion === idPostulante || postulante.idPostulacion === idPostulante;
        if (matchesId) {
          return { 
            ...postulante, 
            FechaLimiteEvaluacion: fechaFormateada
          };
        }
        return postulante;
      })
    );
  };

  const refreshTableAfterEdit = async () => {
    setTableRefreshLoading(true);
    const api = searchPostulantesAPI(searchCriteria.trim(), 1, 20);
    
    try {
      const response = await executeGet(api);
      if (responseCode200(response)) {
        sucessManageSearchCallback(response);
      } else {
        console.error('Error response:', response);
        mostrarMensajeDeErrorConToast(response);
      }
    } catch (error) {
      console.error('Error en refreshTableAfterEdit:', error);
    } finally {
      setTableRefreshLoading(false);
    }
  };

  const parseFecha = (value) => {
    if (!value) return null;
    if (value instanceof Date && !Number.isNaN(value.getTime())) return value;

    const dateText = String(value).trim();
    const isoMatch = dateText.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
      const [, year, month, day] = isoMatch;
      const parsedIso = new Date(Number(year), Number(month) - 1, Number(day));
      return Number.isNaN(parsedIso.getTime()) ? null : parsedIso;
    }

    const latinMatch = dateText.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{2,4})$/);
    if (!latinMatch) return null;

    const [, dayText, monthText, yearText] = latinMatch;
    const fullYear = yearText.length === 2 ? Number(`20${yearText}`) : Number(yearText);
    const parsedLatin = new Date(fullYear, Number(monthText) - 1, Number(dayText));
    return Number.isNaN(parsedLatin.getTime()) ? null : parsedLatin;
  };

  const searchByFechasRegistro = () => {
    if (!(fechaRegistroInicio && fechaRegistroFin)) {
      toast.warn('Debe ingresar ambas fechas');
      return;
    }

    setFechaRegistroFiltro({ inicio: fechaRegistroInicio, fin: fechaRegistroFin });
    setPaginator(prev => ({ ...prev, CurrentPage: 1 }));
  };

  const filteredFormValues = useMemo(() => {
    let resultado = formValues;

    // Filtrar por estados seleccionados
    const idsEstadosSeleccionados = selectedFilters[KEYS_FILTERS.Estados]?.map(option => option.id) || [];
    if (idsEstadosSeleccionados.length > 0) {
      resultado = resultado.filter((fila) => {
        const idEstado = fila?.IdEstado || fila?.idEstado;
        return idsEstadosSeleccionados.includes(idEstado);
      });
    }

    // Filtrar por fechas de registro si hay rango
    if (!(fechaRegistroFiltro.inicio && fechaRegistroFiltro.fin)) return resultado;

    const fechaInicio = parseFecha(fechaRegistroFiltro.inicio);
    const fechaFin = parseFecha(fechaRegistroFiltro.fin);
    if (!fechaInicio || !fechaFin) return resultado;

    return resultado.filter((fila) => {
      const fechaFila = parseFecha(fila?.fechaRegistro);
      return fechaFila && fechaFila >= fechaInicio && fechaFila <= fechaFin;
    });
  }, [formValues, fechaRegistroFiltro, selectedFilters]);

  const sucessManageSearchCallback = async (response) => {
    const responseData = response?.data.data?.Data;
    
    if (responseData) {
      // Si viene con estructura de paginación (búsqueda paginada)
      if (responseData.Items) {
        setFormValues(Array.isArray(responseData.Items) ? responseData.Items : []);
        setPaginator({ 
          TotalItems: responseData.TotalItems || 0,
          FirsItemPage: responseData.FirsItemPage || 1,
          LastItemPage: responseData.LastItemPage || 0,
          TotalPages: responseData.TotalPages || 1,
          CurrentPage: responseData.CurrentPage || 1
        });
      } else {
        // Fallback para respuesta simple (sin búsqueda)
        const postulantesData = responseData || [];
        setFormValues(Array.isArray(postulantesData) ? postulantesData : []);
        setPaginator({ 
          TotalItems: Array.isArray(postulantesData) ? postulantesData.length : 0, 
          FirsItemPage: 1, 
          LastItemPage: Array.isArray(postulantesData) ? postulantesData.length : 0, 
          TotalPages: 1, 
          CurrentPage: 1 
        });
      }
    } else {
      // Fallback vacío
      setFormValues([]);
      setPaginator({ 
        TotalItems: 0, 
        FirsItemPage: 0, 
        LastItemPage: 0, 
        TotalPages: 0, 
        CurrentPage: 1 
      });
    }
  };

  const limpiarBusqueda = () => {
    setSearchCriteria("");
    setPaginator(lastData => ({ ...lastData, CurrentPage: 1 }));
    setSelectedFilters({});
    setFechaRegistroInicio(null);
    setFechaRegistroFin(null);
    setFechaRegistroFiltro({ inicio: null, fin: null });
    setUuidKey(uuidv4());
  };

  // Obtener estados únicos de los datos actuales en la tabla
  const getEstadosFromData = () => {
    const estadosMap = {};
    formValues.forEach(fila => {
      const idEstado = fila?.IdEstado || fila?.idEstado;
      const nombreEstado = fila?.EstadoPostulante || fila?.estadoPostulante || 'Sin estado';
      if (idEstado && !estadosMap[idEstado]) {
        estadosMap[idEstado] = { id: idEstado, label: nombreEstado };
      }
    });
    return Object.values(estadosMap);
  };

  const handleCreatePostulante = () => {
    setIsEditMode(false);
    setPostulanteToEdit(null);
    setShowModalCrear(true);
  };

  const handleEditPostulante = async (idPostulante, isEditModeFromIcon = true) => {
    try {
      console.log('📝 Iniciando edición de postulante ID:', idPostulante, 'Edit mode:', isEditModeFromIcon);
      const response = await executeGet(getPostulanteByIdAPI(idPostulante));
      if (responseCode200(response)) {
        const postulanteData = response.data.data.Data || response.data.data || response.data;
       // console.log('📤 Respuesta del backend para edición:', postulanteData);
        
        // ✅ Usar evaluaciones directamente del backend (ya incluye las asociadas)
        if (postulanteData.evaluaciones && Array.isArray(postulanteData.evaluaciones)) {
         // console.log('✅ Evaluaciones encontradas en respuesta del backend:', postulanteData.evaluaciones);
        } else {
          console.log('⚠️ No se encontraron evaluaciones en la respuesta del backend');
          // Fallback: buscar en lista local si el backend no las devuelve
          const postulanteEnLista = formValues.find(p => 
            (p.idPostulacion || p.IdPostulacion) === idPostulante
          );
          
          if (postulanteEnLista && postulanteEnLista.evaluaciones) {
            postulanteData.evaluaciones = postulanteEnLista.evaluaciones;
           // console.log('🔄 Usando evaluaciones de lista local:', postulanteData.evaluaciones);
          } else {
           // console.log('❌ No se encontraron evaluaciones ni en backend ni en lista local');
            postulanteData.evaluaciones = [];
          }
        }
        
        setPostulanteToEdit(postulanteData);
        setIsEditMode(isEditModeFromIcon);
        setShowModalCrear(true);
      } else {
        mostrarMensajeDeErrorConToast(response);
      }
    } catch (error) {
      console.error('Error al cargar postulante para editar:', error);
    }
  };

  const handleCloseModal = () => {
    setShowModalCrear(false);
    setPostulanteToEdit(null);
    setIsEditMode(false);
  };

  const handleFilterSelected = (res, key) => {
    setSelectedFilters(lastData => ({ ...lastData, [key]: res }));
    setPaginator(lastData => ({ ...lastData, CurrentPage: 1 })); // Resetear a página 1 cuando cambian filtros
  };

  const handlePostulanteCreated = (postulante, isEdit = false) => {
    //console.log('🔍 handlePostulanteCreated llamado:', { postulante, isEdit });
    
    // Extraer datos si vienen en formato {Code, StatusCode, Message, Data}
    const postulanteData = postulante?.Data || postulante;
    console.log('📊 Datos extraídos del postulante:', postulanteData);
    
    if (isEdit && postulanteData) {
      // Edición: actualizar solo el registro específico
      console.log('✅ Ejecutando updatePostulanteInList con datos:', postulanteData);
      updatePostulanteInList(postulanteData);
    } else if (!isEdit && postulanteData) {
      // Creación con datos: agregar al inicio de la lista (modo optimista)
      console.log('✅ Ejecutando addPostulanteToList con datos:', postulanteData);
      addPostulanteToList(postulanteData);
    } else {
      // Fallback: recargar datos (solo si no hay datos del postulante)
     // console.log('⚠️ Ejecutando fallback - refreshTableAfterEdit');
      if (!isEdit) {
        // Para nuevos postulantes, ir a página 1 ya que aparecen al inicio
        setPaginator(prev => ({ ...prev, CurrentPage: 1 }));
      }
      refreshTableAfterEdit();
    }
  };

  useDidMountEffect(() => {
    // El filtrado de estados es 100% frontend, solo resetear a página 1
    setPaginator(prev => ({ ...prev, CurrentPage: 1 }));
  }, [selectedFilters]);

  useDidMountEffect(() => {
    setPaginator(prev => ({ ...prev, CurrentPage: 1 }));
    manageSearch(1, true);
  }, [searchCriteria]);

  useDidMountEffect(() => {
    jsonNoEstaVacio(extraData) && updateFiltersWithExtraData(allFilters, extraData, setFilters);
  }, [extraData]);

  useEffect(() => {
    init();
  }, []);

  if (loading) return <SpinnerLoading />;

  return (
    <div className="app-wrapper">
      <div className="no-disponible-en-mobile">
        <div style={{ display: 'flex', alignItems: 'stretch', position: 'relative' }}>
          <div style={{ position: 'fixed', left: 0, top: 0, bottom: 0, width: '130px', overflowY: 'auto', zIndex: 100 }}>
            <SidebarProcesosSeleccion />
          </div>
          <Wrapper className="App" style={{ flex: 1, minWidth: 0, marginLeft: '130px' }}>
          <PageHeader title="Gestión de Nuevas Postulaciones" />

          <div className="generic-buscador-container">
            <SearchBar 
              value={searchCriteria} 
              onChange={setSearchCriteria} 
              cleanSearch={limpiarBusqueda} 
              manageSearch={manageSearch}
              placeholder="Buscar por nombre, documento, email, celular..."
              loading={searchLoading}
            />
            
            <PageButtons>
              <button 
                onClick={handleCreatePostulante}
                className='btn generic-button-buscador'
                disabled={searchLoading}
              >
                Crear Nuevo
              </button>
            </PageButtons>
          </div>

          <div className="container-fluid body-content">
            <div className="table-scroll pt-3">
              <table className="table table-hover">
                <thead className="listar-thead">
                  <tr className="font-gothan-medium">
                    <th className="text-center px-1" style={{ minWidth: '180px' }}>
                      <FormDatePicker
                        description={<label style={{ fontSize: '12px', color: '#212529' }}>Fecha Registro</label>}
                        fechaInicio={fechaRegistroInicio}
                        fechaFin={fechaRegistroFin}
                        setFechaInicio={setFechaRegistroInicio}
                        setFechaFin={setFechaRegistroFin}
                        searchByFechas={searchByFechasRegistro}
                        key={uuidKey}
                      />
                    </th>
                    <th className="col-4 text-center">
                      <div style={{ width: "300px" }}>Nombre Completo</div>
                    </th>
                    <th className="col-2 text-center">Contacto</th>
                    {/* Cambio visual: "Tipo de Cargo" por "Tipo de Evaluación" para mejor comprensión del usuario */}
                    <th className="text-center" style={{ minWidth: "120px" }}>Tipo de Evaluación</th>
                    <th className="text-center" style={{ minWidth: "250px" }}>Cargo</th>
                    {/* <th className="text-center" style={{ minWidth: "120px" }}>Nivel</th> */}
                    <th className="text-center" style={{ minWidth: "150px" }}>Especialidad</th>
                    {/* <th className="text-center">
                      <label className='mb-0'>Paso</label>
                    </th> */}
                    <th className="text-center" style={{ minWidth: "180px" }}>
                      <label className='mb-0'>Responsable</label>
                    </th>
                    <th className="text-center" style={{ minWidth: "100px" }}>
                      <label className='mb-0 text-wrap'>Fecha Límite Evaluación</label>
                    </th>
                    <th className='text-center' style={{ minWidth: "100px" }}>
                      <EstadoFilter
                        options={getEstadosFromData()}
                        description="Estado"
                        selectedEstados={selectedFilters[KEYS_FILTERS.Estados] ?? []}
                        onFilterChange={(res) => handleFilterSelected(res, KEYS_FILTERS.Estados)}
                      />
                    </th>
                    <th className="col-1 text-center">Acciones</th>
                  </tr>
                </thead>
                <TableWebBody
                  filas={filteredFormValues}
                  manageSearch={manageSearch}
                  onEditPostulante={handleEditPostulante}
                  onUpdatePostulanteStatus={updatePostulanteStatus}
                  onUpdatePostulanteFechaLimite={updatePostulanteFechaLimite}
                  onCorreoEnviado={refreshTableAfterCorreo}
                  isLoading={tableRefreshLoading}
                />
              </table>
              <PaginatorV2 paginator={paginator} setPaginator={setPaginator} manageSearch={manageSearchForPaginator} />
            </div>
          </div>
          </Wrapper>
        </div>
        
        {showModalCrear && (
          <div className="modal-contactanos modal-response-ficha-background">
            <ModalCrearPostulante
              showModal={showModalCrear}
              setShowModal={handleCloseModal}
              onPostulanteCreated={handlePostulanteCreated}
              postulanteToEdit={postulanteToEdit}
              isEditMode={isEditMode}
              setShowModalMensajeIsPostulanteActivo={setShowModalMensajeIsPostulanteActivo}
              setMensajeIsPostulanteActivo={setMensajeIsPostulanteActivo}
            />
          </div>
        )}

        {showModalMensajeIsPostulanteActivo && (
            <div className="">
                <ModalMensajePostulanteActivo
                    showModal={showModalMensajeIsPostulanteActivo}
                    setShowModal={setShowModalMensajeIsPostulanteActivo}
                    mensaje={mensajeIsPostulanteActivo}
                />
            </div>
        )}
      </div>
    </div>
  );
};

export default NuevosPostulantes;